import React from "react";
import { SITE_CONFIG } from "../data/config";
import { MessageCircle, ExternalLink } from "lucide-react";

const Header = () => {
  const waLink = `https://wa.me/${SITE_CONFIG.whatsappNumber}`;

  return (
    <header className="sticky top-0 z-40 backdrop-blur-lg bg-[#0A1128]/85 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 relative flex items-center justify-between gap-3">
        {/* Left action */}
        <a
          href={SITE_CONFIG.storeUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-xl bg-white/5 hover:bg-white/10 text-white border border-white/10 text-sm font-semibold transition-colors z-10"
        >
          <ExternalLink className="w-4 h-4" />
          <span className="hidden sm:inline">المتجر</span>
        </a>

        {/* Centered logo (main branding) */}
        <a
          href="/"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center"
          aria-label="Rush Store"
        >
          <img
            src={SITE_CONFIG.logoUrl}
            alt="Rush Store"
            className="rush-logo h-14 sm:h-20 w-auto object-contain select-none"
            draggable={false}
          />
        </a>

        {/* Right action */}
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-semibold transition-colors z-10"
        >
          <MessageCircle className="w-4 h-4" />
          <span className="hidden sm:inline">تواصل واتساب</span>
        </a>
      </div>
    </header>
  );
};

export default Header;
